import { compose, padding } from 'styled-system'
import styled from 'styled-components/macro'
import { BadgeWarningSVG } from 'src/components/Icons/Basic'

export const GetStartedBox = styled.article.attrs({
  py: 'l',
})`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;

  min-width: 900px;
  height: 200px;
  background: #f6f9fc;
  border-radius: 6px;
  ${compose(padding)}
  width: 100%;
`

export const GetStartedText = styled.div`
  display: flex;
  gap: 8px;
  p {
    margin: auto;
    font-size: 16px;
    font-weight: 400;
  }
  align-items: center;
  justify-content: center;
`

export const EndDateSVG = styled(BadgeWarningSVG)`
  margin-bottom: 4px;
`
